var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V9.103a8.83 8.83 0 0 0-8.829-8.827z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 9.103a8.829 8.829 0 0 0-8.828-8.828h-39.501L256 136.337 48.329.276H8.828A8.828 8.828 0 0 0 0 9.103v22.836L207.671 168 0 304.061v22.836a8.829 8.829 0 0 0 8.828 8.828h39.501L256 199.663l207.671 136.061h39.501a8.829 8.829 0 0 0 8.828-8.828V304.06L304.329 168 512 31.939V9.103z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 31.939v272.122L304.329 168zM0 304.061V31.939L207.671 168z",
    fill: "#464655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/jm.bd7d859f069e07c4857c7d9a3b29a149.svg";
export { ForwardRef as ReactComponent };